// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1-Vg5","checkboxCol":"Table_checkboxCol__NNoBA","emailCol":"Table_emailCol__-VXJK","actionCol":"Table_actionCol__324Ap"};